import * as React from 'react';
import { api, handleApiError } from 'services/api';

type AbonedInvoiceJustificationsPayload = {
  ids: number[];
};

export const useAbonedInvoiceJustifications = () => {
  const abonedInvoiceJustifications = React.useCallback(
    async (payload: AbonedInvoiceJustificationsPayload) => {
      try {
        await api.put('/invoice/justifications/aboned', payload);
      } catch (e) {
        throw handleApiError(e);
      }
    },
    [],
  );

  return {
    abonedInvoiceJustifications,
  };
};
